module.exports = __webpack_public_path__ + "static/media/kamili-feelings.6fcd56e1.md";